import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

function Svg({ children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function PrescriptionIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 8h2a2 2 0 0 1 0 4H9" />
      <path d="M9 8v8" />
      <path d="m11 12 3 4" />
    </Svg>
  );
}

export function LabReportIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 3v6L4.5 17A2 2 0 0 0 6.3 20h11.4a2 2 0 0 0 1.8-3L15 9V3" />
      <path d="M8 3h8" />
      <path d="M7 14h10" />
    </Svg>
  );
}

export function ScanIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M3 7V5a2 2 0 0 1 2-2h2" />
      <path d="M17 3h2a2 2 0 0 1 2 2v2" />
      <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
      <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  );
}

export function DoctorVisitIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 3v7a4 4 0 0 0 8 0V3" />
      <path d="M4 3h4" />
      <path d="M12 3h4" />
      <path d="M10 14v3a4 4 0 0 0 8 0v-1" />
      <circle cx="18" cy="15" r="2" />
    </Svg>
  );
}

export function VaccineIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="m18 2 4 4" />
      <path d="m17 7 3-3" />
      <path d="m19 9-8.5 8.5a2.12 2.12 0 1 1-3-3L16 6" />
      <path d="m9 11 4 4" />
      <path d="m5 15-3 3 2 2 3-3" />
    </Svg>
  );
}

export function VitalsIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </Svg>
  );
}

export function DocumentIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <path d="M14 3v6h6" />
      <path d="M8 13h8" />
      <path d="M8 17h5" />
    </Svg>
  );
}
